import React, { useEffect, useState, useMemo } from 'react';
import './assets/css/adminlte.min.css';
import './assets/vendor/fontawesome-free/css/all.min.css' //
import './assets/css/custom.css'
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

import MainRoutes from './routes/Routes';
import ProfileContext from './services/profileContext';
import { getApiData } from './services/apiService';
import helpers from './services/helpers';
import useSessionGuard from './services/sessionGuard';
import PreLoader from './components/parts/PreLoader';
import initTreeView from './services/initTreeView';

function App() {
    useSessionGuard()

    const [loading, setLoading] = useState(true);
    const [account, setAccount] = useState([]);
    
    useEffect(() => {
        initTreeView()
        const is_authenticated = helpers.isAuthenticated();
        //Mounted

        async function fetchAccount(){
            let endpoint = helpers.createUrl(`V1/account/profile`)
            const data = await getApiData(endpoint)

            if(data){
                setLoading(false)
                setAccount(data.data)
            }
        }

        if(is_authenticated){
          fetchAccount();
        }
        else{
          setLoading(false)
        }
    }, []);

  const contextValue = useMemo(() => ({ account }), [account]);

  if (loading) {
    return <PreLoader isLoading={loading}/>;
  }

  return (
    <div className="App wrapper">
      <ProfileContext.Provider value={contextValue}>
        <MainRoutes />
      </ProfileContext.Provider>
    </div>
  );
}

export default App;
